import * as React from "react";
import { Link } from "gatsby";
import Navbar from "../components/navbar/Main";
import HomePageFooterMain from "../components/footer/HomePageFooterMain";

const NotFoundPage = () => {
  return (
    <main>
      <Navbar />
      <div className="font-redhatMedium flex flex-col items-center justify-center min-h-[95vh] bg-gray-100 text-center">
        <p className="text-[15vw] md:text-[3vw] text-[#FF0000] mb-2">404</p>
        <p className="text-[4vw] md:text-[1vw]">Page not found</p>
        <p className="text-[4vw] md:text-[1vw] mb-[1vw]">
          Oops! We can't seem to find the page you're looking for!
        </p>
        <p className="text-[5vw] md:text-[1vw]">
          <Link to="/" className="underline text-[#1534AD] font-redhatMedium">
            Click here to go back Home
          </Link>
        </p>
      </div>
      <HomePageFooterMain />
    </main>
  );
};

export default NotFoundPage;

export const Head = () => (
  <>
    <title>Not found</title>
    <meta name="robots" content="noindex, nofollow" />
  </>
);
